/* eslint-disable no-param-reassign */
import { useState, useCallback } from 'react';
import api from '~/services';
import log from '~/helpers/log';

export default function useContactInfo(values = []) {
  const [contactInfo, setNewContactValue] = useState(values);

  const setContactInfo = useCallback(
    async id => {
      try {
        const contact = await api.contacts.get.contactInfo(id);
        const contactValue = contact.data;

        if (contactValue.groups && typeof contactValue.groups !== 'undefined') {
          contactValue.groups = contactValue.groups.filter(
            item => item.parent === true
          );
        }
        setNewContactValue(contactValue);
      } catch (err) {
        log.error('Failed to setup contact info.', err);
      }
    },
    [setNewContactValue]
  );

  return [contactInfo, setContactInfo];
}
